/**
 * @flow
 */

const codes = {
  // Auth Errors
  INVALID_USERNAME_PASSWORD: 'INVALID_USERNAME_PASSWORD',
  TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',

  REGISTRATION_ERROR: 'REGISTRATION_ERROR',
  LEGACY_ACCOUNT_ERROR: 'LEGACY_ACCOUNT_ERROR',

  DIRECTORY_ALREADY_EXISTS: 'DIRECTORY_ALREADY_EXISTS',
  HOOK_INITIALIZATION_ERROR: 'HOOK_INITIALIZATION_ERROR',
  INVALID_ARGUMENT: 'INVALID_ARGUMENT',
  INVALID_ASSETS: 'INVALID_ASSETS',
  INVALID_BUNDLE: 'INVALID_BUNDLE',
  INVALID_JSON: 'INVALID_JSON',
  INVALID_MANIFEST: 'INVALID_MANIFEST',
  INVALID_OPTIONS: 'INVALID_OPTIONS',
  INVALID_VERSION: 'INVALID_VERSION',
  NGROK_ERROR: 'NGROK_ERROR',
  NO_EXPO_SERVER_PORT: 'NO_EXPO_SERVER_PORT',
  NO_PACKAGE_JSON: 'NO_PACKAGE_JSON',
  NO_PACKAGER_PORT: 'NO_PACKAGER_PORT',
  NO_PORT_FOUND: 'NO_PORT_FOUND',
  NO_PROJECT_ROOT: 'NO_PROJECT_ROOT',
  NO_SDK_VERSION: 'NO_SDK_VERSION',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN',
  PLATFORM_NOT_SUPPORTED: 'PLATFORM_NOT_SUPPORTED',
  PUBLISH_VALIDATION_ERROR: 'PUBLISH_VALIDATION_ERROR',
  WONT_OVERWRITE_WITHOUT_FORCE: 'WONT_OVERWRITE_WITHOUT_FORCE',
  XCODE_LICENSE_NOT_ACCEPTED: 'XCODE_LICENSE_NOT_ACCEPTED',

  //Shell Apps
  CREDENTIAL_ERROR: 'CREDENTIAL_ERROR',
};

export default codes;
export type ErrorCodes = typeof codes;
